module.exports = __webpack_public_path__ + "static/media/Premier-Logo.d345391a.svg";